export const ATTACHMENT_CONTENT_OTHER = 'OTHER'

export const ATTACHMENT_CONTENT_OPTIONS = [
  { label: '教育部学籍在线验证报告', value: 'STUDENT_STATUS_ONLINE_VERIFICATION' },
  { label: '教育部学历证书电子注册备案表', value: 'EDUCATION_CERTIFICATE_ELECTRONIC_REGISTRATION' },
  { label: '中国高等教育学位在线验证报告', value: 'DEGREE_ONLINE_VERIFICATION' },
  { label: '其他', value: ATTACHMENT_CONTENT_OTHER }
]

const CHSI_TERMINAL_STATUSES = new Set([
  'ONLINE_VALID',
  'FAILED_EXPIRED',
  'FAILED_PARSE',
  'FAILED_MISMATCH'
])

export const CHSI_VERIFY_STATUS_MAP = {
  PENDING: {
    label: '学信网核验中',
    className: 'text-warning',
    showDetail: false
  },
  ONLINE_VALID: {
    label: '学信网核验通过',
    className: 'text-success',
    showDetail: true
  },
  FAILED_EXPIRED: {
    label: '报告失效，需人工复核',
    className: 'text-warning',
    showDetail: true
  },
  FAILED_PARSE: {
    label: '解析失败，需人工复核',
    className: 'text-warning',
    showDetail: true
  },
  FAILED_MISMATCH: {
    label: '报名信息与报告不一致',
    className: 'text-warning',
    showDetail: true
  }
}

export const CHSI_REPORT_TYPE_MAP = {
  STUDENT_STATUS_ONLINE_VERIFICATION: '教育部学籍在线验证报告',
  EDUCATION_CERTIFICATE_ELECTRONIC_REGISTRATION: '教育部学历证书电子注册备案表',
  DEGREE_ONLINE_VERIFICATION: '中国高等教育学位在线验证报告',
  UNKNOWN: '学信网报告'
}

export const CHSI_MAPPED_INFO_LABELS = [
  { key: 'name', label: '姓名' },
  { key: 'schoolName', label: '学校或授予单位' },
  { key: 'major', label: '专业' },
  { key: 'graduationOrAwardDate', label: '毕业/离校/获学位日期' },
  { key: 'studentStatus', label: '学籍状态' },
  { key: 'educationResult', label: '毕结业结论' },
  { key: 'degreeName', label: '所授学位' }
]

export const isChsiVerifyTerminal = (status) => {
  return CHSI_TERMINAL_STATUSES.has(status)
}

export const shouldShowChsiSummary = (verification) => {
  return verification != null
}

export const getChsiReportItems = (verification) => {
  if (!verification || !Array.isArray(verification.items)) {
    return []
  }
  return verification.items
}

export const shouldShowChsiItemDetailBtn = (item) => {
  if (!item?.verificationId) {
    return false
  }
  if (item.status === 'PENDING') {
    return false
  }
  return isChsiVerifyTerminal(item.status)
}

/** @deprecated V1 根级详情按钮，仅 items 缺失时降级使用 */
export const shouldShowChsiDetailBtn = (verification) => {
  if (!verification?.chsiVerificationId) {
    return false
  }
  const statusConfig = CHSI_VERIFY_STATUS_MAP[verification.chsiVerifyStatus]
  return !!statusConfig?.showDetail && isChsiVerifyTerminal(verification.chsiVerifyStatus)
}

export const getChsiOverallSummaryDisplay = (verification) => {
  if (!verification) {
    return {
      message: '学信网核验状态未知',
      className: 'text-warning'
    }
  }

  if (verification.verified === true) {
    return {
      message: '学信网报告核验通过',
      className: 'text-success'
    }
  }

  const status = verification.chsiVerifyStatus

  if (status === 'PENDING') {
    return {
      message: CHSI_VERIFY_STATUS_MAP.PENDING.label,
      className: CHSI_VERIFY_STATUS_MAP.PENDING.className
    }
  }

  if (verification.summaryText) {
    return {
      message: verification.summaryText,
      className: 'text-warning'
    }
  }

  const statusConfig = CHSI_VERIFY_STATUS_MAP[status]
  if (statusConfig) {
    return {
      message: statusConfig.label,
      className: statusConfig.className
    }
  }

  return {
    message: '学信网核验状态未知',
    className: 'text-warning'
  }
}

export const getChsiItemStatusDisplay = (item) => {
  if (!item) {
    return {
      label: '—',
      className: 'text-muted'
    }
  }

  const statusConfig = CHSI_VERIFY_STATUS_MAP[item.status]
  if (statusConfig) {
    return {
      label: statusConfig.label,
      className: statusConfig.className
    }
  }

  if (item.verified === true) {
    return {
      label: '学信网核验通过',
      className: 'text-success'
    }
  }

  return {
    label: '学信网核验状态未知',
    className: 'text-warning'
  }
}

/** @deprecated 使用 getChsiOverallSummaryDisplay */
export const getChsiSummaryDisplay = (verification) => {
  const overall = getChsiOverallSummaryDisplay(verification)
  return {
    ...overall,
    showDetail: shouldShowChsiDetailBtn(verification)
  }
}

export const getChsiReportTypeLabel = (reportType) => {
  if (!reportType) {
    return CHSI_REPORT_TYPE_MAP.UNKNOWN
  }
  return CHSI_REPORT_TYPE_MAP[reportType] || CHSI_REPORT_TYPE_MAP.UNKNOWN
}

export const getChsiDetailConclusion = (detail) => {
  if (!detail) {
    return { label: '—', className: 'text-primary' }
  }

  if (detail.status === 'ONLINE_VALID' && detail.verified && !detail.manualReviewRequired) {
    return { label: '核验通过', className: 'text-success' }
  }

  if (detail.status === 'FAILED_MISMATCH') {
    return { label: '报名信息与报告不一致', className: 'text-warning' }
  }

  if (detail.manualReviewRequired || (detail.status && String(detail.status).startsWith('FAILED'))) {
    return { label: '需要人工复核', className: 'text-warning' }
  }

  if (detail.verified && !detail.manualReviewRequired) {
    return { label: '核验通过', className: 'text-success' }
  }

  return { label: '核验不通过', className: 'text-warning' }
}

export const normalizeAttachmentContent = (value) => {
  return value || ATTACHMENT_CONTENT_OTHER
}
